
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateResponse} from './ConfigUpdateResponse';
import {FieldModelConfigUpdateResponse} from './ConfigUpdateResponse';
import {MarkupProfile} from '../core/MarkupProfile';
import {FieldModelMarkupProfile} from '../core/MarkupProfile';

/**
 * MarkupProfileCreateResponse struct
 */
class MarkupProfileCreateResponse extends ConfigUpdateResponse {
  /**
   * Initialize struct
   * @param {!ConfigUpdateResponse=} parent
   * @param {!MarkupProfile=} markupProfile
   * @constructor
   */
  constructor (parent = new ConfigUpdateResponse(), markupProfile = new MarkupProfile()) {
    super()
    super.copy(parent)
    this.MarkupProfile = markupProfile
  }

  /**
   * Copy struct (shallow copy)
   * @this {!MarkupProfileCreateResponse}
   * @param {!MarkupProfileCreateResponse} other Other struct
   * @returns {!MarkupProfileCreateResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.MarkupProfile != null) {
      this.MarkupProfile = MarkupProfile.fromObject(other.MarkupProfile)
    } else {
      this.MarkupProfile = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!MarkupProfileCreateResponse}
   * @returns {!MarkupProfileCreateResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new MarkupProfileCreateResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new MarkupProfileCreateResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!MarkupProfileCreateResponse}
   * @param {!MarkupProfileCreateResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof MarkupProfileCreateResponse)) {
      throw new TypeError('Instance of MarkupProfileCreateResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!MarkupProfileCreateResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      MarkupProfile: ((this.MarkupProfile != null) ? this.MarkupProfile : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return MarkupProfileCreateResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!MarkupProfileCreateResponse} other Object value
   * @returns {!MarkupProfileCreateResponse} Created struct
   */
  static fromObject (other) {
    return new MarkupProfileCreateResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!MarkupProfileCreateResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return MarkupProfileCreateResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!MarkupProfileCreateResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6138
  }
}

export { MarkupProfileCreateResponse };

/**
 * Fast Binary Encoding MarkupProfileCreateResponse field model
 */
class FieldModelMarkupProfileCreateResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateResponse(buffer, 4 + 4)
    this.MarkupProfile = new FieldModelMarkupProfile(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the ConfigUpdateResponse field model
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!FieldModelConfigUpdateResponse} ConfigUpdateResponse field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.MarkupProfile.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.MarkupProfile.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelMarkupProfileCreateResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6138
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.MarkupProfile.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarkupProfile.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarkupProfile.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {!MarkupProfileCreateResponse} fbeValue Default value, defaults is new MarkupProfileCreateResponse()
   * @returns {!MarkupProfileCreateResponse} MarkupProfileCreateResponse value
   */
  get (fbeValue = new MarkupProfileCreateResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {!MarkupProfileCreateResponse} fbeValue MarkupProfileCreateResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.MarkupProfile.fbeSize) <= fbeStructSize) {
      fbeValue.MarkupProfile = this.MarkupProfile.get()
    } else {
      fbeValue.MarkupProfile = new MarkupProfile()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarkupProfile.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {!MarkupProfileCreateResponse} fbeValue MarkupProfileCreateResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelMarkupProfileCreateResponse}
   * @param {MarkupProfileCreateResponse} fbeValue MarkupProfileCreateResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.MarkupProfile.set(fbeValue.MarkupProfile)
  }
}

export { FieldModelMarkupProfileCreateResponse };

/**
 * Fast Binary Encoding MarkupProfileCreateResponse model
 */
class MarkupProfileCreateResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelMarkupProfileCreateResponse(this.buffer, 4)
  }

  /**
   * Get the MarkupProfileCreateResponse model
   * @this {!MarkupProfileCreateResponseModel}
   * @returns {!FieldModelMarkupProfileCreateResponse} model MarkupProfileCreateResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!MarkupProfileCreateResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!MarkupProfileCreateResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return MarkupProfileCreateResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!MarkupProfileCreateResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelMarkupProfileCreateResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!MarkupProfileCreateResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!MarkupProfileCreateResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!MarkupProfileCreateResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!MarkupProfileCreateResponseModel}
   * @param {!MarkupProfileCreateResponse} value MarkupProfileCreateResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!MarkupProfileCreateResponseModel}
   * @param {!MarkupProfileCreateResponse} value MarkupProfileCreateResponse value, defaults is new MarkupProfileCreateResponse()
   * @return {!object} Deserialized MarkupProfileCreateResponse value and its size
   */
  deserialize (value = new MarkupProfileCreateResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new MarkupProfileCreateResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new MarkupProfileCreateResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!MarkupProfileCreateResponseModel}
   * @param {!number} prev Previous MarkupProfileCreateResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { MarkupProfileCreateResponseModel };
